export function mergeDateAndTime(dateWithDatePart: Date = new Date(), dateWithTimePart: Date = new Date()) {
    // Extract date components from the first Date object
    if (dateWithDatePart && dateWithTimePart) {
        const year = dateWithDatePart.getFullYear();
        const month = dateWithDatePart.getMonth();
        const day = dateWithDatePart.getDate();

        // Extract time components from the second Date object
        const hours = dateWithTimePart.getHours();
        const minutes = dateWithTimePart.getMinutes();
        const seconds = dateWithTimePart.getSeconds();
        const milliseconds = dateWithTimePart.getMilliseconds();

        // Create a new Date object by merging date and time components
        return new Date(year, month, day, hours, minutes, seconds, milliseconds);
    }
}

export function convertSecondsTime(secs: number = 0) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    return {
        h: hours,
        m: minutes,
        s: seconds
    };
}

export function getCurrentUnixTimestamp(): number {
    const currentUnixTimestamp: number = Math.floor(Date.now() / 1000); // Current time in seconds (Unix time)
    return currentUnixTimestamp;
}

export function getSecondsLeftFromNow(futureUnixTime: number): number {
    const currentTime = getCurrentUnixTimestamp();
    const differenceInSeconds = Math.max(futureUnixTime - currentTime, 0);
    return differenceInSeconds;
}
